import { customElement } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { isQuotationDTO } from 'components/ordering/quotation/components/is-quotation-dto.js'
import { consume } from '@lit/context'
import {
  activeQuotationContext,
  addQuotationToBasketContext
} from 'components/ordering/quotation/components/context/quotation-context.js'
import { hostDisplayContents } from 'components/ordering/quotation/components/quotation.style.js'
import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'

@customElement('csc-quotation-add-to-cart-button')
export class CSCQuotationAddToCartButton extends LitElement {
  static override styles: CSSResultGroup = [hostDisplayContents]

  @consume({ context: activeQuotationContext, subscribe: true })
  private quotation!: QuotationDTO | NotFoundError

  @consume({ context: addQuotationToBasketContext })
  private addQuotationToBasket!: (quotationId: number) => Promise<void>

  private async addToBasket() {
    if (!isQuotationDTO(this.quotation)) return
    await this.addQuotationToBasket(this.quotation.id)
  }

  private mayBeAddedToBasket() {
    return isQuotationDTO(this.quotation)
      // the merchant has accepted the quotation
      && this.quotation.status === 'accepted'
      // quotations are processed through the basket, not erp
      && this.quotation.canAddToBasket
      // this user is allowed to add this quotation to the basket
      && this.quotation.canApprove
  }

  override render() {
    if (!this.mayBeAddedToBasket()) return nothing

    return html`
      <cse-button
        variant="primary"
        @click=${this.addToBasket}
      >
        <cse-icon icon-role="csc-quotation-request-header.add-to-cart-button" slot="prefix"></cse-icon>
        ${t('quotation_request_header_add_to_cart_button', {
          ns: 'csc-quotation-request-header',
          default: 'Add to cart'
        })}
      </cse-button>
    `
  }
}
